import { api } from '../api.js';
import { useAdmin } from './EditLink.js';
import { AdminImageActions } from './AdminImageActions.js';

export function PageImageActions({ fragrance, onSaved, triggerSlot }: {
  fragrance: { id: string; name: string; brand?: { name: string } | null; concentration?: string; isOriginal?: boolean; media?: { id: string } | null }; onSaved: () => void; triggerSlot?: HTMLElement | null;
}) {
  const { admin, csrfToken } = useAdmin();
  if (!admin) return null;
  async function save<T>(url: string, method: string, body: unknown) {
    const multipart = body instanceof FormData;
    return api<T>(url, { method, headers: { 'X-CSRF-Token': csrfToken, ...(!multipart ? { 'Content-Type': 'application/json' } : {}) }, body: multipart ? body : JSON.stringify(body) });
  }
  return <section className="page-image-editor" aria-label={'Manage image for ' + fragrance.name}>
    <AdminImageActions triggerSlot={triggerSlot} fragrance={fragrance} mediaId={fragrance.media?.id ?? ''} save={save} onChanged={onSaved} />
  </section>;
}
